"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodingStr = exports.buildAddShader = exports.buildDrawShader = void 0;
var shader_1 = __importDefault(require("../gl-utils/shader"));
var vbo_1 = __importDefault(require("../gl-utils/vbo"));
var build_shaders_1 = require("./build-shaders");
var encodingStr = "vec4 encodeObstacle(vec2 normal) {\n  normal = clamp(normalize(normal), -1.0, 1.0);\n  return vec4(0.5 * normal + 0.5, 0, 0);\n}\nvec2 decodeObstacle(vec4 texel) {\n  return 2.0 * texel.rg - 1.0;\n}";
exports.encodingStr = encodingStr;
var drawVert = "attribute vec2 aCorner; //{0,1}x{0,1}\n\nvarying vec2 sampleCoords;\n\nvoid main(void) {\n    sampleCoords = aCorner;\n    gl_Position = vec4(2.0*aCorner - 1.0, 0.0, 1.0);\n}";
var drawFrag = "precision mediump float;\n\nuniform sampler2D uObstacles;\n\nvarying vec2 sampleCoords;\n\n___ENCODING___\n\nvoid main(void) {\n    vec2 obstacle = decodeObstacle(texture2D(uObstacles, sampleCoords));\n    if (dot(obstacle, obstacle) < 0.5)\n        discard;\n\n    gl_FragColor = vec4(0.5*obstacle + 0.5, 0, 0);\n}";
var addObstacleVert = "uniform vec2 uSize; //relative, in [0,1]x[0,1]\nuniform vec2 uPos; //relative, in [0,1]x[0,1]\n\nattribute vec2 aCorner; //in {-1,+1}x{-1,+1}\n\nvarying vec2 toCenter;\n\nvoid main(void) {\n    toCenter = -aCorner;\n\n    vec2 pos = uPos + aCorner * uSize;\n\n    gl_Position = vec4(2.0 * pos - 1.0, 0, 1);\n}";
var addObstacleFrag = "precision mediump float;\n\nvarying vec2 toCenter;\n\n___ENCODING___\n\nvoid main(void) {\n    float dist = length(toCenter);\n    if (dist > 1.0)\n        discard;\n\n    vec2 normal = -toCenter / dist;\n    gl_FragColor = encodeObstacle(normal);\n}";
var includes = [
    { toReplace: "___ENCODING___", replacement: encodingStr },
];
var drawSrc = new build_shaders_1.ShaderSrc(drawVert, drawFrag);
drawSrc.batchReplace(includes);
var addSrc = new build_shaders_1.ShaderSrc(addObstacleVert, addObstacleFrag);
addSrc.batchReplace(includes);
function buildDrawShader(gl) {
    var shader = new shader_1.default(gl, drawSrc.vert, drawSrc.frag);
    shader.a["aCorner"].VBO = vbo_1.default.createQuad(gl, 0, 0, 1, 1);
    return shader;
}
exports.buildDrawShader = buildDrawShader;
function buildAddShader(gl) {
    var shader = new shader_1.default(gl, addSrc.vert, addSrc.frag);
    shader.a["aCorner"].VBO = vbo_1.default.createQuad(gl, -1, -1, 1, 1);
    return shader;
}
exports.buildAddShader = buildAddShader;
